function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNesSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 52.916665 52.916666",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "ConcaveTriangle-2-2",
    refX: 0,
    refY: 0,
    orient: "auto-start-reverse",
    markerWidth: 0.5,
    markerHeight: 0.5,
    viewBox: "0 0 1 1",
    preserveAspectRatio: "xMidYMid"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.7)",
    d: "M -2,-4 9,0 -2,4 c 2,-2.33 2,-5.66 0,-8 z",
    style: {
      fill: "context-stroke",
      fillRule: "evenodd",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ConcaveTriangle-2-2-3",
    refX: 0,
    refY: 0,
    orient: "auto-start-reverse",
    markerWidth: 0.5,
    markerHeight: 0.5,
    viewBox: "0 0 1 1",
    preserveAspectRatio: "xMidYMid"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.7)",
    d: "M -2,-4 9,0 -2,4 c 2,-2.33 2,-5.66 0,-8 z",
    style: {
      fill: "context-stroke",
      fillRule: "evenodd",
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g7",
    transform: "matrix(1.3073584,0,0,1.3073584,-7.2995125,-8.1050196)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#9e9e9e",
      strokeWidth: 3,
      strokeLinejoin: "round"
    },
    markerEnd: "url(#ConcaveTriangle-2-2)",
    d: "M 15.508473,40.436652 C 5.8978678,35.20997 5.347361,21.785832 12.376945,15.773197"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#9e9e9e",
      strokeWidth: 3,
      strokeLinejoin: "round"
    },
    markerEnd: "url(#ConcaveTriangle-2-2-3)",
    d: "m 36.376536,11.390159 c 9.610605,5.226682 10.161112,18.65082 3.131529,24.663455"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbee41",
      fillOpacity: 1,
      stroke: "#fbee41",
      strokeWidth: 1.16800412,
      strokeLinejoin: "round",
      strokeOpacity: 1,
      strokeLinecap: "round"
    },
    d: "m 22.820044,34.945868 8.480812,-11.04046 -5.163809,0.437733 2.081636,-8.244808 -8.39154,13.059176 6.664152,-2.403464 -3.678029,8.19363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNesSymbol);
export default __webpack_public_path__ + "static/media/NESSymbol.c410e0230f6bc52b82380a68be014dc5.svg";
export { ForwardRef as ReactComponent };